import React, { FC } from 'react'
import styled from 'styled-components'
import { theme, Row, Space } from 'ui'


const Content = styled.div`
  background-color:${theme.color.white};
  padding: 1rem;
  border-radius: 8px;
`

const StyledText = styled.div<{ align?: string }>`
  flex:1;
  line-height:24px;
`
const StyledMainTitle = styled.div`
  text-decoration: underline;
  font-size: 2rem;
  text-align: center;
`
const StyledDescriptionText = styled.div`
`

const StyledSubTitle = styled.div`
  text-decoration: none;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 500;
`
const StyledRow = styled(Row)`
  align-items: flex-start;
  margin-left:10px;
`
const StyledMainText = styled.div<{ align?: string }>`
  margin:5px 0;
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
`

const Section = ({ number, text }: { number: string, text: any }) => {
  return (
    <StyledRow>
      <div style={{ lineHeight: '24px' }}>
        <div>{number}</div>
      </div>
      <Space />
      {text}
    </StyledRow>
  )
}

const B = (props: any) => <b>{props.children}</b>
const Link = (props: any) => <a {...props} />

interface Props {
  heightMultiply?: number
}

const uri = 'https://mekometerms.z6.web.core.windows.net/'

const Terms: FC<Props> = () => {
  return (
    <Content>
      <StyledSubTitle>
        פלטפורמת 'מקומי' –  תנאי שימוש ומדיניות פרטיות
      </StyledSubTitle>
      <StyledSubTitle
      >
        ***הכתוב מטה מתייחס באופן שווה לכל מין ומגדר, ומנוסח בלשון זכר מטעמי נוחות בלבד***
      </StyledSubTitle>
      <StyledSubTitle
      >
        מתחת לגיל 18? הכתוב מטה עשוי להיות מעט מורכב. אנא היוועץ במבוגר אחראי לפני השימוש בפלטפורמה
      </StyledSubTitle>
      
      
      <StyledMainText
        align={'left'}
      >
        <u>א. כללי</u>:
      </StyledMainText>
      <Section
        number={'1.'}
        text={<StyledText
          align={'left'}
        >
         מטרת מסמך תנאי שימוש זה הינה להבהיר ולהסדיר את היחסים בין המשתמש ו/או הלקוח אשר עושה שימוש במגוון שירותי האגודה, לבין האגודה.
         </StyledText>}
      />
      <Section
        number={'2.'}
        text={<StyledText
          align={'left'}
        >
מסמך תנאים כלליים זה מסדיר את תנאי הענקת הרישיון ללקוח לעשות שימוש במערכת (כהגדרתה להלן) ו/או באפליקציית "מקומי" ו/או באתרי האגודה ולקבל באמצעותם שירותים שונים. התנאים הכלליים מהווים חלק בלתי נפרד מטופס ההזמנה. התנאים הכלליים, מדיניות הפרטיות, טופס ההזמנה, וכל מסמך נוסף שיצורף אליהם מהווים הסכם מחייב בין הצדדים (יחדיו: "<strong>ההסכם</strong>").
         </StyledText>}
      />
      <Section
        number={'3.'}
        text={<StyledText
          align={'left'}
    >תנאים כלליים אלו מסדירים וחלים על מגוון שירותים המסופקים על ידי מקומי-נט פתרונות תשלום ומידע בקיבוצים אגש"ח בע"מ (להלן: ״<strong>האגודה</strong>״) וייתכן שחלקם אינם רלוונטיים לשירותים המסופקים ללקוח. יש לקרוא תנאים כללים אלו בהקשר לשירותים הספציפיים אשר תספק האגודה ללקוח כמפורט בטופס ההזמנה.       </StyledText>}
      />

      <Section
        number={'4.'}
        text={<StyledText
          align={'left'}
    >בכל מקרה של סתירה בין אילו מהוראות התנאים הכלליים, לבין טופס ההזמנה ו/או כל מסמך שיצורף אליהם, יגברו הוראות התנאים הכלליים, למעט אם נאמר מפורשות אחרת בתנאים כלליים אלו.       </StyledText>}
      />

<StyledMainText
        align={'left'}
      >
       <u>ב. פרשנות:</u>
      </StyledMainText>
   <Section
        number={'5.'}
        text={<StyledText
          align={'left'}
    >   
    למונחים שלהלן תהא בתנאים כלליים אלו המשמעות שלצדם:
    <p><strong>"השירותים": </strong>השירותים שיסופקו ללקוח באמצעות המערכת, אשר מפורטים בטופס ההזמנה ובתנאים כללים אלו; וכן כל השירותים הדיגיטליים שיסופקו למשתמש באמצעות: אתרי האגודה, אמצעים דיגיטליים ומערכות מקושרות. השירותים מתייחסים לכל המערכות הנלוות של האגודה, כגון: מערכת הזמנות, קלפי דיגיטל, קופות וירטואליות, מערכת הפצת הודעות, תשלומים וסליקה וכיו"ב.</p>
<p><strong>"המערכת": </strong>מערכת סליקה ו/או תשלומים ו/או הפצת הודעות ו/או ניהול מידע בקהילה קיבוצית, ו/או קלפי דיגיטלית ו/או קופות וירטואליות ו/או מערכת הזמנות וכל מערכת נלוות של האגודה, כמפורט בטופס ההזמנה, בכל פלטפורמה בה היא מוצעת כיום ו/או תוצע בעתיד, בין אם בצורת אפליקציה סלולארית בחנות, גישה באמצעות דפדפן אינטרנט או כל דרך אחרת. המונח "המערכת" כולל גם את כל אלה: (א) ממשק ניהול לשימוש מנהלי המערכת (כהגדרתם להלן); (ב) כל גרסה חדשה ככל שתהיה, לרבות מודול, פיתוח ויכולת נוספת ככל שיפותחו בעתיד למערכת; (ג) הממשקים (כהגדרתם להלן); יצוין כי, המערכת הינה פלטפורמה לפרסום באמצעות צדדים שלישיים לצורכי מתן שירות לחברי הקהילה.</p>
<p><strong>"אפליקציית מקומי" &ndash; </strong>האפליקציה משמשת את המשתמשים לצרכים שונים, ובין היתר מנהלת את ממשק ההתקשרות ביניהם לבין האגודה, לרבות לצורך סליקה ו/או תשלומים ו/או הפצת הודעות ו/או ניהול מידע בקהילה הקיבוצית וכיו"ב.</p>
<p><strong>״המועד הקובע״: </strong>מועד אישור טופס ההזמנה על ידי הלקוח והאגודה;</p>
<p>"<strong>זכויות קניין רוחני</strong>": כל זכות קניין רוחני מכל מין וסוג, לרבות, תוכנות מחשב, קוד מחשב&nbsp; ( source code ו-object code), מבני קבצים, מודולים, ממשקי משתמש, זכויות יוצרים, עיצובים, מדגמים, סימני מסחר, מוניטין, וכן כל זכות המקבילה לכל אחד מן האמורים לעיל וכל זכות הנגזרת מכל אחד מן האמורים לעיל, בין אם מוגנת על פי חוק ו/או רישום ובין אם לאו;</p>
<p>"<strong>חברי הקהילה</strong>": (1) חברים באגודה השיתופית החקלאית; (2) תושבים ועובדים בקהילה;</p>
<p>"<strong>טופס הזמנה</strong>": טופס הזמנת שירות אליו מצורפים תנאים כלליים אלו, כפי שיעודכן מעת לעת בהסכמה הדדית של הצדדים בכתב, אשר כולל את הפרטים המסחריים להתקשרות בין הצדדים ומפרט בין היתר, את סוג המערכת לגביה מקבל הלקוח רישיון ואת השירותים שיסופקו לו באמצעותה;</p>
<p>"<strong>ממשקים</strong>": כל ממשק שיפותח על ידי האגודה למשאבי הלקוח, לרבות למערכות ו/או לחומרה של הלקוח, כמפורט בטופס ההזמנה;</p>
<p><strong>"מנהלי מערכת"</strong>: משתמשים (כהגדרתם להלן) שהנם נציגי הלקוח, ואשר נבחרו על ידי הלקוח כמי שיהיו בעלי הרשאות גישה וניהול במערכת, ינהלו את המערכת, יבצעו פעולות שונות, ובין היתר, יהיו אחראים על משלוח הודעות לחברי הקהילה באמצעות המערכת;</p>
<p><strong>"משתמש" </strong>או<strong> "משתמש מורשה"</strong>: חבר קהילה, מנהל מערכת, וכל נציג של הלקוח, אשר הלקוח הגדיר אותו&nbsp; כבעל גישה למערכת, לרבות מי שהוריד את המערכת למכשיר הסלולארי שלו;</p>
<p>"<strong>נתוני הלקוח</strong>": הנתונים אשר מוזנים, מיובאים, מועלים, מדוורים או מסופקים באופן אחר על ידי הלקוח ו/או משתמש מורשה ו/או באמצעות הממשקים במסגרת ו/או בקשר עם השימוש במערכת, ו/או נתונים כאמור אשר ייאגרו על ידי המערכת במהלך השימוש בשירותים על ידי הלקוח/ משתמשים, ו/או יועברו לאגודה על ידי הלקוח, כגון אך לא רק, פרטי משתמש שונים הכוללים בין היתר: פרטי זיהוי משתמשים &ndash; שם מלא, מספר תעודת זהות, כתובת, דוא"ל, טלפון, קשרים משפחתיים, וכן מידע פיננסי, כגון פרטי חיוב משתמש, דפי תקציב ושכר, פרטי רכישות, פרטי אשראי (בהתאם לתקן DSS PCI), פרטי חשבון בנק, ופרטי פעילות של משתמשים, לרבות הודעות ומסרים המופצים באמצעות המערכת על ידי משתמשים ומנהלי מערכת, תכנים המועלים על ידי משתמשים למערכת, לרבות נתוני שימוש שונים, כגון מועד משלוח וקבלה של הודעות, סטטוס קריאת הודעות, מיקום (לגבי הודעות מבוססות מיקום &ndash; לא ניטור GPS), פרטי הצבעות דיגיטליות, פרוטוקולים, תורנויות וקריאות שירות. נתוני הלקוח כוללים גם כל תוכן שיספק הלקוח לצורך הכללתו במערכת, בין אם הוא מוזן במישרין על ידי הלקוח או מנהלי המערכת ובין אם באמצעות האגודה;</p>
<p>"<strong>תנאי שימוש</strong>": תנאי שימוש במערכת - לרבות מדיניות פרטיות, הזמינים במערכת.</p>
<p><strong><u>ג. הצהרות</u></strong> <strong><u>והתחייבויות הלקוח</u></strong> - הלקוח מצהיר ומתחייב כי:</p>
    </StyledText>}
      />
    <Section
        number={'6.'}
        text={<StyledText
          align={'left'}
      > 
    הוא קיבל ו/או יקבל כדין, עובר להצטרפותו לשירות, את אישורו של כל משתמש, להעביר ולמסור <strong>לאגודה </strong>ולמאגר המידע שבבעלותה<strong>,</strong> פרטים ומידע אישי לגבי המשתמש ובקשר אליו, למטרות השימוש של האגודה ובהתאם למדיניות הפרטיות ותנאי השימוש שלה, וכן בקשר עם ולצורך אספקת השירותים על ידי האגודה, לרבות אך לא רק, נתוני לקוח כהגדרתם לעיל, ובינם פרטי זיהוי משתמשים, מספר תעודת זהות, כתובת, דוא"ל, טלפון, מידע פיננסי, כגון פרטי חיוב משתמש, פרטי רכישות, פרטי אשראי, פרטי חשבון בנק וכדומה, ומתחייב כי לא תהיה לכל משתמש כאמור כל טענה כלפי האגודה ו/או מי מטעמה בקשר עם האמור, לרבות אך לא רק, טענות שעניינן הפרת פרטיות המשתמשים ו/או מי מהם, ואם תעלה טענה כזו כלפי האגודה, הלקוח מתחייב לשפות את האגודה באופן מידי ביחס לכל הנזקים וההוצאות הקשורות בטענות אלו, לרבות הוצאות התגוננות משפטית.

      </StyledText>}
    />
    <Section
        number={'7.'}
        text={<StyledText
          align={'left'}
      > 
  הלקוח והמשתמשים יעשו שימוש במערכת ובשירותים אך ורק בהתאם להוראת הרישיון, מדיניות הפרטיות ותנאי השימוש.

      </StyledText>}
    />

    <Section
        number={'8.'}
        text={<StyledText
          align={'left'}
      >ידוע לו שהמערכת ו/או האפליקציה כוללת אך ורק את המאפיינים, השירותים והפונקציות המפורטים בטופס ההזמנה, וכי בכפוף להוראות ההסכם, ככל שבעתיד יורחבו השירותים שניתן לספק באמצעות המערכת ביחס למפורט בטופס ההזמנה, ו/או ככל שתחליט האגודה להרחיב את פעילות המערכת לפלטפורמות נוספות מעבר לאילו המפורטות בטופס ההזמנה ("<strong>הרחבה</strong>"), תהיה זכאית האגודה לתמורה נוספת בגין כל הרחבה כאמור, בהתאם למחירון האגודה באותה העת.

      </StyledText>}
    />

    <Section
        number={'9.'}
        text={<StyledText
          align={'left'}
      >
דוע ללקוח כי שיתוף הפעולה של הלקוח ושל צדדים שלישיים נחוץ לשם אספקת כלל השירותים המוצעים, לרבות לשם התממשקות המערכת ו/או האפליקציה למשאבי הלקוח ככל שנחוץ, והוא ישתף עם האגודה פעולה באופן מלא בעניין וכן יסייע לאגודה על מנת שצדדים שלישיים מטעמו ו/או המספקים לו שירותים ישתפו גם הם פעולה עם האגודה בעניין.

      </StyledText>}
    />


<StyledMainText
        align={'left'}
      >
       <u>ד. רישיון</u>
      </StyledMainText>

    <Section
        number={'10.'}
        text={<StyledText
          align={'left'}
      >כנגד תשלום מלוא התמורה, כהגדרתה להלן, ובכפוף לקיום יתר התחייבויותיו של הלקוח כמפורט בהסכם, במלואן ובמועדן, האגודה מעניקה בזאת ללקוח ולכל אחד מהמשתמשים המורשים, רישיון אישי, לא בלעדי, בלתי ניתן להעברה ו/או המחאה, ואינו ניתן לרישוי משנה ((sublicensing, ניתן לביטול, לעשות שימוש במערכת במשך תקופת ההסכם בלבד ולמטרות המפורטות בתנאים כלליים אלו ובטופס ההזמנה בלבד ("<strong>הרישיון</strong>").
      </StyledText>}
    />
    <Section
        number={'11.'}
        text={<StyledText
          align={'left'}
      >הרישיון ניתן לצורך שימוש בלעדי, עצמי בלבד של הלקוח, אך ורק לצורך המטרה אשר לשמה פותחה המערכת על ידי האגודה.</StyledText>}
    />
    <Section
        number={'12.'}
        text={<StyledText
          align={'left'}
      >
        ככל שהמערכת כוללת רכיבים השייכים לצדדים שלישיים שאינם האגודה, לגבי אלה מוענקת ללקוח רשות שימוש בהתאם לתנאי הרישיון של בעלי הזכויות באותם רכיבים.
      </StyledText>}
    />
<StyledMainText
        align={'left'}
      >
      <u>ה. שירותים</u>
      </StyledMainText>

      <Section
        number={'13.'}
        text={<StyledText
          align={'left'}
      >
<strong>משתמשים מורשים</strong>: הגישה למערכת מוגבלת למשתמשים מורשים בלבד. הלקוח מתחייב לא לגשת למערכת או להתיר שימוש במערכת על ידי אדם או גורם שאינו בבחינת "משתמש מורשה".
      
</StyledText>}/>
<Section
        number={'14.'}
        text={<StyledText
          align={'left'}
      >
      <strong>מנהלי מערכת:</strong> מנהלי המערכת יהיו אחראים לניהול המערכת מטעם הלקוח, לרבות למשלוח הודעות ועדכונים לשאר המשתמשים בנושאים שונים באמצעות ממשק ניהול המערכת. הלקוח אחראי להעניק למנהלי המערכת הרשאות שימוש במערכת בדרגות הרשאה שונות בהתאם לפעולות שעליהם לבצע במערכת. הלקוח אחראי בלעדית לפעולות מנהלי המערכת מטעמו.
</StyledText>}/>
<Section
        number={'15.'}
        text={<StyledText
          align={'left'}
      >
      <strong>הדרכה:</strong> האגודה תדריך את מנהלי המערכת באופן השימוש במערכת וניהולה וכן בדבר אופן ההתמודדות עם שאלות תפעוליות של משתמשים וכן אופן פתרון תקלות שונות.
      </StyledText>}/>
<Section
        number={'16.'}
        text={<StyledText
          align={'left'}
      >
      <strong>משאבי הלקוח וממשקים</strong>: הלקוח אחראי לספק את המשאבים והציוד המתוארים בטופס ההזמנה, ככל שנדרשים כאלו לצורך מתן השירותים. הלקוח אחראי על תחזוקה משאבי הלקוח בעצמו ועל חשבונו, לרבות, כל מערכות הגישה לאינטרנט, חומרה, דפדפנים, תוכנת הנהלת חשבונות, מסופונים (ככל שאינם מסופקים באמצעות האגודה), וכל תשתית, חומרה ותכנה אחרת הנחוצות בכדי לעשות שימוש במערכת. דרישות משאבי הלקוח תשתיות / חומרה הן בבחינת המינימום הנדרש לשם פעולת המערכת ואספקת השירותים, והאחריות לעמידה בהן היא של הלקוח. ככל שהלקוח לא יעמיד את המשאבים הנדרשים (תשתיות / חומרה) לשם אספקת השירותים, יידחה מועד אספקת השירותים עד למועד בו יועמדו כל המשאבים כאמור על ידי הלקוח. האגודה תספק ללקוח, כחלק מהמערכת, את הממשקים למשאבי הלקוח המפורטים בטופס ההזמנה. ככל שבמועד כלשהו לאחר המועד הקובע יחליף הלקוח איזה ממשאבי הלקוח (כך לדוגמא - מערכת הנהלת חשבונות), אזי התאמת הממשקים למשאבים החלופיים תהיה כרוכה בעלויות בהתאם למחירון האגודה באותה עת. ככל שהשירותים כוללים אספקת מסופונים ו/או כל חומרה אחרת באמצעות האגודה, יהיה הדבר כפוף לתנאי האחריות והשירות של ספק החומרה הרלוונטי<strong>, </strong>אשר אחראי לאספקת שירותי תיקונים ותחזוקה ללקוח.
      </StyledText>}/>

<Section
        number={'17.'}
        text={<StyledText
          align={'left'}
      >
     <strong>תמיכה:</strong> במהלך תקופת ההסכם, האגודה תספק ללקוח תמיכה טכנית ברמה שניה. הלקוח אחראי לתמיכה ברמה 1 ("1st tier"), הכוללת מתן מענה לשאלות משתמשים ביחס לשימוש במערכת, וכן טיפול ואבחון בתקלות פשוטות המתגלות במערכת ו/או בשימוש בה. הלקוח אחראי להדריך את המשתמשים כי בכל מקרה של תקלה או שאלה תפעולית עליהם לפנות ראשית למנהלי המערכת, ולפעול לפי הנחיותיהם, טרם פנייה לאגודה.
      </StyledText>}/>      

<StyledMainText
        align={'left'}
      >
<u>ו. נתוני לקוח</u>
      </StyledMainText>

<Section
        number={'18.'}
        text={<StyledText
          align={'left'}
      >
     הלקוח אחראי בלעדית לחוקיות, אמינות, שלמות, דיוק ואיכות נתוני הלקוח ועמידתם בהוראות כל דין, החוקים והתקנות החלים. לאגודה אין אחריות, והיא לא תהיה אחראית בשום דרך שהיא לנתוני הלקוח, בכלל זאת לחוקיות, אמינות, דיוק ו/או איכות נתוני הלקוח. מבלי לגרוע מן האמור, ככל שבנתוני הלקוח גלומות זכויות של צדדים שלישיים (כגון אך לא רק זכויות יוצרים), הלקוח אחראי באופן בלעדי להשגת ההרשאות הנחוצות מאותם צדדים שלישיים לעשיית שימוש בנתוני הלקוח כאמור.
      </StyledText>}/>      
<Section
        number={'19.'}
        text={<StyledText
          align={'left'}
      >
    האגודה רשאית (אולם אינה חייבת) - להסיר מן המערכת נתוני לקוח אשר לפי שיקול דעתה של האגודה מהווים הפרה של הוראות הדין ו/או זכויות צדדים שלישיים והלקוח מוותר על כל טענה כלפי האגודה בעניין.
      </StyledText>}/>      
<Section
        number={'20.'}
        text={<StyledText
          align={'left'}
      >
    הלקוח מעניק בזאת לאגודה רישיון לא-בלעדי, ונטול תמלוגים, לאיסוף, שימוש, עיבוד, הצגה, העתקה, ואחסון נתוני לקוח על מנת לספק את השירותים ללקוח. הרישיון כולל מתן הרשאה לאגודה להעביר את נתוני הלקוח ו/או כל חלק מהם, לצדדים שלישיים (כגון מס"ב, חברות סליקת אשראי), אשר נחוצים לשם אספקת השירותים ללקוח. כמו כן, האגודה רשאית לייצר מנתוני הלקוח מידע אנונימי (כמוגדר להלן), ולחשוף אותו לצדדים שלישיים המהווים ספקי שירות שלה, לשם אספקה, שיפור ופרסום המערכת והשירותים של האגודה. "<strong>מידע אנונימי</strong>": משמעו מידע אשר אינו מאפשר זיהוי של היחיד, כגון מידע מצטבר וניתוח על שימוש במערכת, ומידע שנוצר מעיבוד וניתוח נתוני הלקוח. האגודה הינה הבעלים של כל המידע האנונימי אשר נאסף או התקבל על ידי האגודה.

       </StyledText>}/>      
<Section
        number={'21.'}
        text={<StyledText
          align={'left'}
      >
        נתוני הלקוח יישמרו במאגר מידע בבעלות האגודה וישמשו למטרותיה, והיא תפעל ביחס לנתוני הלקוח (לרבות לעניין העברתם לצדדים שלישיים) בהתאם למדיניות הפרטיות של האגודה, המהווה חלק בלתי נפרד מתנאי השימוש.
       </StyledText>}/>    

<StyledMainText
        align={'left'}
      >
<u>ז. תקופת ההסכם / תקופת הרישיון </u>
      </StyledMainText>
<Section
        number={'22.'}
        text={<StyledText
          align={'left'}
      >
       ההסכם יהיה בתוקף החל מהמועד הקובע ויימשך כל עוד לא הגיע לסיומו בהתאם לתנאים כלליים אלו <strong>(״תקופת ההסכם״</strong>). הרישיון יהיה בתוקף במהלך תקופת ההסכם.
       </StyledText>}/>    

<StyledMainText
        align={'left'}
      >
<u>ח. תמורה ותנאי תשלום</u>
      </StyledMainText>
<Section
        number={'23.'}
        text={<StyledText
          align={'left'}
      >
        <strong><u>תמורה</u></strong>: בתמורה לרישיון והשירותים הניתנים ללקוח לפי הסכם זה, ישלם הלקוח לאגודה כל תשלום (חד פעמי ו/או קבוע) כמפורט בטופס ההזמנה ("<strong>התמורה</strong>").
       </StyledText>}/>   
       
<Section
        number={'24.'}
        text={<StyledText
          align={'left'}
      >
        <strong><u>תנאי תשלום:</u></strong> כל תשלום שעל הלקוח לשלם לאגודה לפי ההסכם, ישולם, בתוספת מע"מ כדין ובחלוף לא יאוחר מ-30 ימים ממועד החשבונית שתוצא על ידי האגודה ללקוח.
</StyledText>}/>   

<Section
        number={'25.'}
        text={<StyledText
          align={'left'}
      >
        האגודה רשאית לשנות את דמי השירות בכל עת בכפוף לתשעים (90) ימי הודעה מוקדמת ללקוח.
     </StyledText>}/>   
<Section
        number={'26.'}
        text={<StyledText
          align={'left'}
      >
       <strong><u>איחור בתשלום:</u></strong> היה והלקוח לא ישלם לאגודה כל תשלום המגיע לה לפי הסכם זה במועד הקבוע לתשלומו, אז בנוסף לכל זכות או סעד אחר העומד לרשות האגודה, ישלם הלקוח לאגודה ריבית הנהוגה ביחס לחריגה ממסגרת בחשבון חח"ד בבנק הפועלים, מהמועד הקבוע לביצוע התשלום, ועד לקבלתו בפועל על ידי האגודה.
     </StyledText>}/>   

<Section
        number={'27.'}
        text={<StyledText
          align={'left'}
      >
        <strong><u>השעיה</u></strong>: היה והלקוח לא ישלם לאגודה כל תמורה המגיעה לה לפי הסכם זה במועד הקבוע לתשלומה, אזי, האגודה רשאית, מבלי לגרוע מכל סעד העומד לרשות האגודה, להשעות את הגישה של הלקוח והשימוש שלו ושל המשתמשים במערכת ו/או בכל שירות שהלקוח מקבל באמצעות המערכת, עד למועד בו יתקבלו כל התשלומים (כלל ריבית פיגורים) מהלקוח והלקוח מוותר על כל טענה כנגד האגודה בעניין.
     </StyledText>}/> 

<StyledMainText
        align={'left'}
      >
<u>ט. מגבלות שימוש</u>
      </StyledMainText>

<Section
        number={'28.'}
        text={<StyledText
          align={'left'}
      >
מבלי לגרוע מהוראות תנאי השימוש, הלקוח לא יבצע, או ירשה לכל משתמש או צד שלישי לבצע, את האמור להלן: (1) לעקוף, להשבית או להפריע בדרך אחרת לאבטחה של המערכת או לעבודה התקינה של המערכת; (2) לפגוע או לשבש הגנות סיסמה המסדירות את הגישה למערכת - ככל שקיימות; (3) לאפשר לכל צד שלישי שאינו משתמש מורשה לעשות שימוש במערכת; (4) למכור, להשכיר, להחכיר, להעניק רישיון במערכת; (5) לעשות במערכת או בשירותים שימוש שאינו מפורט בטופס ההזמנה או בהסכם זה; (6) להעתיק, לשחזר, לשנות, לעבד, להתאים, לתרגם, לבצע הינדוס לאחור, הידור לאחור, לפרק, לבצע פעולות נגזרות על, או להפיק, או לנסות להפיק, את קוד המקור של המערכת או כל מרכיב שלה; לשדר, לשכפל, למכור, להעניק רישיונות משנה וכיו"ב באפליקציה ו/או במערכת, כולה או חלקה; (7) לעשות שימוש במערכת לעיצוב ו/או לפיתוח שירות או מוצר מתחרים; (8) להסיר, להשחית, להסתיר או לשנות את המערכת או כל הודעות זכויות יוצרים, סימנים מסחריים, או זכויות קנייניות אחרות אשר מסופקים או ניתנים כחלק מהמערכת, או לעשות שימוש או להציג סמלים מסחריים של המערכת אשר שונים מאלה שסופקו על ידי האגודה; (9) לעשות שימוש בשמה, סמלה המסחרי או סימני המסחר של האגודה, ללא הסכמה מראש ובכתב של האגודה; (10) לשלוח, להעלות, לחלק, להעביר או להפיץ באמצעות המערכת כל תוכן בלתי חוקי, משמיץ, מטריד, שנועד להונות, מפר, מגונה או מטעה, או כל וירוסים, תולעים, פגמים , סוסים טרויאניים, קבצים פגומים, מתיחות או חומר הרסני או זדוני אחר; ו/או (11) לעשות שימוש במערכת לכל מטרה בלתי חוקית; (12) לשבש או להפר כל זכות של משתמש אחר באפליקציה, לרבות הזכות לפרטיות ו/או איסוף מידע אישי על המשתמשים באפליקציה ללא הסכמתם המפורשת מראש ובכתב, לרבות באמצעים אוטומטיים; (13( לפגוע בכבודו או בפרטיותו של משתמש אחר ו/או לשנות תוכן שפורסם על ידי משתמש אחר ו/או לפרסם תוכן בשם משתמש אחר ו/או להשתמש באפליקציה ו/או בתוכן המופיע בה כדי לפגוע בשמו הטוב של כל אדם ו/או לפרסם דברי הסתה, הונאה, לשון הרע ו/או כל מידע אחר שהינו שקרי, בלתי אמין או שיש בו כדי לפגוע במזיד.

     </StyledText>}/> 
<Section
        number={'29.'}
        text={<StyledText
          align={'left'}
      >
האגודה רשאית, על פי שיקול דעתה המלא והבלעדי שלא לאשר, להשעות או לחסום, ללא הודעה מראש, את הגישה של הלקוח ו/או כל משתמש ו/או צד שלישי לאפליקציה ו/או למערכת ו/או לכל חלק ממנה או לכל שירות המוצע במסגרתה, במקרים בהם סבורה האגודה, כי בוצעה הפרת תנאי השימוש בשירותים המוצעים, או כי קיימת או קיים חשש כי תיגרם הפרעה מכל סוג שהוא לפעילות התקינה של המערכת או לאספקת השירותים, או חשש להפרת הוראות הדין ו/או זכויות של צדדים שלישיים, ו/או מכל סיבה אחרת לפי שיקול דעתה הבלעדי של האגודה, ומשתמש ו/או צד שלישי כלשהו מוותרים על כל טענה ו/או דרישה ו/או תביעה &nbsp;כנגד האגודה ו/או מי מטעמה בעניין.

     </StyledText>}/> 
     <StyledMainText
        align={'left'}
      >
<u>י. הגבלת אחריות</u><u>&nbsp;</u>
      </StyledMainText>
<Section
        number={'30.'}
        text={<StyledText
          align={'left'}
      >
        המערכת והשירותים ניתנים לשימוש על ידי הלקוח על בסיס "כפי שהוא" ("AS IS") או על בסיס "כפי שזמין" (AS" AVAILABLE"). האגודה איננה מתחייבת ו/או מצהירה שפעולתה של המערכת ו/או השירותים יהיו נקייה מהפרעות, תקלות ו/או ליקויים. מבלי לגרוע מן האמור, ידוע ללקוח כי באספקת השירותים ללקוח תלויה המערכת בצדדים שלישיים (כגון מס"ב, גופי סליקת אשראי, רשת האינטרנט, רשת סלולארית וכו'), עליהם אין לאגודה כל שליטה ו/או אחריות. הסעד היחיד והבלעדי של הלקוח ביחס לכל ליקוי, תקלה או הפרעה כאמור, יהיה ניסיון של האגודה, תוך השקעת מאמץ סביר מסחרית, לתקן כל תקלה או ליקוי כאמור ובלבד שמקורו במערכת בלבד.
     </StyledText>}/> 
          
<Section
        number={'31.'}
        text={<StyledText
          align={'left'}
      >
במערכת ו/או באפליקציה עשויים להיות מוצגים, תוכן, פרסומים, פרסומות, כתבות, מידע, שירותים, מוצרים ו/או כל תוכן אחר של צדדים שלישיים ו/או מטעמם, בין באמצעות הפניית המשתמש לאתרים של צדדים שלישיים ו/או באמצעות הצגתם של אלה באפליקציה (להלן "תוכן של צד שלישי"). מבלי לגרוע מהאמור, השימוש של המשתמש בתוכן של צד שלישי הינו בכפוף לתקנון ו/או תנאי השימוש ו/או מדיניות הפרטיות של אותם צדדים שלישיים, ככל שאלה קיימים. מובהר, כי כל חוות דעת, הבעת עמדה, עצה, הצהרה, הצעה, אינפורמציה, שירות ו/או כל תוכן אחר בתוכן של צד שלישי, הינם של אותו צד שלישי והאגודה אינה מעורבת ביצירתם, עריכתם ו/או הפעלתם.
     </StyledText>}/> 

<Section
        number={'32.'}
        text={<StyledText
          align={'left'}
      >
נוסף על האמור, באפליקציה עשויים להיכלל גם קישורים ('לינקים') לאתרי אינטרנט אחרים, אשר אינם מופעלים על-ידי האגודה. הקישורים נועדו אך ורק לנוחותם ולידיעתם של המשתמשים. קישורים אלה אינם בשליטתה של האגודה והיא אינה מפקחת על תוכן האתרים המקושרים. ככל שהאפליקציה מכילה קישורים אלה, אין בכך כדי להעיד על הסכמה ו/או אחריות של האגודה לתכנים המופיעים באתרים המקושרים ו/או מהווה ערובה לאמינותם, עדכניותם, תקינותם או חוקיותם ו/או למדיניות הפרטיות ותנאי השימוש הננקטים על-ידי בעליהם. האגודה אינה אחראית לכל תוצאה אשר תיגרם כתוצאה מהשימוש באתרים המקושרים ו/או מהסתמכות עליהם וממליצה לקרוא בעיון את תנאי השימוש ומדיניות הפרטיות של אתרים אלה, ככל שקיימים, ו/או לפנות לבעלי האתרים המקושרים בכל מקרה של טענה או בקשה בעניין. עוד מובהר, כי האגודה רשאית, בהתאם לשיקול דעתה המלא והבלעדי, להסיר כל קישור מהאפליקציה ו/או להוסיף קישורים נוספים וכי האגודה אינה מתחייבת כי הקישורים לאתרי האינטרנט האמורים יהיו פעילים ויובילו לאתר אינטרנט פעיל.
     </StyledText>}/> 

<Section
        number={'33.'}
        text={<StyledText
          align={'left'}
      >
האגודה לא תהיה אחראית בשום מקרה לתיקון תקלות או כשלים כאמור בכל אחד מהמקרים הבאים:
<ul>
<li>תקלות שמקורן בליקויים, פגמים ותקלות בסביבת העבודה (חומרה ותוכנה) של הלקוח, לרבות מערכות ההפעלה, דפדפן האינטרנט וכיו"ב;</li>
<li>תקלות שמקורן ליקויים, פגמים ותקלות במשאבי הלקוח;</li>
<li>תקלות שמקורן בצדדים שלישיים, לרבות אך לא רק מס"ב, גופי סליקת אשראי, רשתות תקשורת, מערכת האינטרנט, רשתות סלולאריות, מערכת החשמל כיוצ"ב;</li>
<li>תקלות שמקורן שימוש במערכת ו/או בשירותים שלא בהתאם לרישיון או לכל הוראה אחרת בהסכם;</li>
<li>כל שינוי במערכת ו/או בשירותים שלא נעשה על ידי האגודה;</li>
<li>שימוש במערכת ו/או בשירותים באופן המנוגד לחוק;</li>
<li>כמו כן, האגודה לא תהיה אחראית בכל צורה שהיא למקרה בו יתעוררו בעיות במערכת ו/או בשירותים בשל מעשה או מחדל של הלקוח ו/או מי מהמשתמשים המורשים ו/או כל מי מטעמו, לרבות עקב תאונה, רשלנות, שימוש בלתי נכון ובניגוד להוראות האגודה.</li>
</ul>
     </StyledText>}/> 

<Section
        number={'34.'}
        text={<StyledText
          align={'left'}
      >
מבלי לגרוע מהאמור בסעיפים 30-33 לעיל, <strong>ידוע ללקוח כי האגודה משמשת אך ורק כצינור להעברת נתונים ומידע אשר התקבלו מהלקוח לצדדים שלישיים כגון, מרכז הסליקה הבנקאי / חברת סליקת אשראי, ומגופים אלו ללקוח, וכי האגודה תפעל במסגרת הסכם זה גם על פי הנחיות שתקבל מגופים אלו.</strong> <strong>לאגודה אין כל אחריות לכל פעולה של גופים אלו.</strong> מבלי לגרוע מן האמור, ידוע ללקוח כי ייתכן ותהיינה טעויות ו/או תקלות ו/או חוסרים, בתהליך העברת המידע ללקוח ו/או ממנו, בין שמקורן בלקוח, בין שמקורן בגופים אלו, ובין שמקורן במערכת ו/או באגודה מכל סיבה שהיא. הלקוח מוותר על כל טענה או תביעה מכל סוג שהם כלפי האגודה ו/או מי מטעמה בעניין ופוטר את האגודה מכל אחריות לכל נזק ו/או הפסד שהוא (כספי או אחר) שייגרם ללקוח כתוצאה ו/או בקשר עם האמור, וזאת למעט במקרה בו יוכח כי הנזק נגרם בשל פעולה פעלה בזדון של האגודה.
     </StyledText>}/> 
        
<Section
        number={'35.'}
        text={<StyledText
          align={'left'}
      >
        הלקוח מאשר כי בכל מקרה של סתירה בין נתונים המצויים אצל האגודה ו/או במס"ב ו/או חברות סליקת האשראי, לבין אלו המצויים אצל הלקוח, יקבעו הנתונים המצויים אצל האגודה ו/או במס"ב ו/או אצל חברות סליקת האשראי -&nbsp; לפי העניין.
</StyledText>}/> 


<Section
        number={'36.'}
        text={<StyledText
          align={'left'}
      >
       על אף האמור בהוראות כל דין, הצדדים מסכימים בזאת כי אחריותה המצטברת והכוללת של האגודה לכל נזק, אובדן או הפסד שייגרמו ללקוח ו/או לצדדים שלישיים כתוצאה ו/או בקשר עם השימוש במערכת, לרבות בגין תביעות צד שלישי נגד הלקוח, תהיה מוגבלת לנזקים ישירים בלבד, ואיננה כוללת נזקים עקיפים, תוצאתיים ו/או אובדן מידע, אובדן נתונים, אובדן הכנסות, ולא תעלה בכל מקרה ומכל עילה שהיא (חוזית, נזיקית או אחרת) על סך התשלומים ששולמו בפועל ישירות על ידי הלקוח לאגודה, מכוח ההסכם, במהלך 12 החודשים שקדמו למועד העלאת תביעה כאמור על ידי הלקוח. למען הסר ספק, מובהר כי בכל מקרה לא תעלה אחריותה המצטברת והכוללת של האגודה כאמור, על סך התמורה ששולמה לאגודה בפועל על ידי הלקוח במהלך תקופה של 12 חודשים כאמור, בגין כל הנזקים גם יחד. מובהר כי הסעדים המפורטים בסעיף זה הם הסעדים היחידים להם יהיה זכאי הלקוח, מכל עילה או סיבה שהיא, לפי ההסכם ו/או לפי דין. מגבלת האחריות של האגודה לא תחול במקרה של נזק שייגרם על ידה בזדון.
</StyledText>}/> 
<Section
        number={'37.'}
        text={<StyledText
          align={'left'}
      >
        האפליקציה מתוכננת להיות בפעילות 24 שעות ביממה, למעט מקרים בהם תהא מושבתת לצורך תחזוקתה ו/או מכל סיבה אחרת, ולאחר שהלקוחות עודכנו על כך מראש.

 </StyledText>}/> 
<Section
        number={'38.'}
        text={<StyledText
          align={'left'}
      >
        מובהר בזאת, כי ייתכן שיחולו שינויים במועדים המצוינים בתנאי שימוש אלה, לרבות שעות פעילות האפליקציה וכדומה, והכל בהתאם לשיקול דעתה המלא והבלעדי של האגודה.
 </StyledText>}/> 

     <StyledMainText
        align={'left'}
      >
<u>יא. תנאים מיוחדים</u>
      </StyledMainText>

<Section
        number={'39.'}
        text={<StyledText
          align={'left'}
      >
<strong>חיובים של חברי הקהילה שהועברו בפועל לחשבון הבנק של הלקוח אולם נדחו מכל סיבה שהיא (כגון אך לא רק אכ"מ), יימשכו בחזרה מחשבון הלקוח, בהתאם להודעת דחיה מהבנק, והלקוח מוותר על כל טענה כלפי האגודה בעניין. </strong>
 </StyledText>}/> 

<Section
        number={'40.'}
        text={<StyledText
          align={'left'}
      >
      <strong>חיוב מס"ב אשר נדחה, יגרור אחריו עלויות ללקוח כפי שייקבע על ידי מס"ב. דחיית חיוב בפעם השנייה תהיה כרוכה בעלות גבוהה יותר מן הדחיה הראשונה, וכך הלאה בכל ניסיון חיוב, בהתאם למחירון מס״ב. ידוע ללקוח כי יהיה עליו לשאת בלעדית בכל עלויות הדחייה. </strong>
 </StyledText>}/> 

<Section
        number={'41.'}
        text={<StyledText
          align={'left'}
      >
        <strong>המערכת נמצאת בשלב ניסיוני של פיילוט, וכי יידרש זמן עד שהמערכת והשירותים יפעלו בצורה יציבה. הלקוח מודע למשמעויות של הצטרפות לשירותים במסגרת פיילוט, לרבות כי בשלב זה עשויים המערכת והשירותים להיות מלווים בתקלות בתדירות גבוהה באופן חריג, ו/או שלא להביא בהכרח לתוצאות המצופות ו/או הרצויות, והלקוח מוותר על כל טענה כלפי האגודה או מי מטעמה בעניין.</strong>
   </StyledText>}/> 

<StyledMainText
        align={'left'}
      >
<u>יב. זכויות</u> <u>קניין</u> <u>רוחני</u>
      </StyledMainText>
<Section
        number={'42.'}
        text={<StyledText
          align={'left'}
      >
      ביחסים שבין הצדדים, כל זכויות הקניין הרוחני במערכת ו/או באפליקציה בכל חלק ממנה, לרבות הזכויות בכל פיתוח, שיפור, תוספת, יצירה נגזרת ו/או שכלול, עיצובים, איורים, מפות, קטעי אודיו/וידאו, טקסט, גרפיקה, תוכנה, יישום, קוד מקור וכל חומר אחר וכיו"ב (להלן: "<strong>התוכן</strong>" או "<strong>התכנים</strong>"),בין קיימים ובין שיפותחו בעתיד לשירותים המוצעים, לרבות במסגרת ו/או בקשר עם אספקת השירותים, לרבות בכל גרסה חדשה, מוגנים על ידי דיני זכויות יוצרים ויישארו קניינה הבלעדי של האגודה ו/או מי מטעמה ו/או לצד שלישי אשר העניק לאגודה זכות שימוש מלאה בהם והיא רשאית לנהוג בהם מנהג בעלים ועל פי שיקול דעתה הבלעדי. משכך, חל איסור מוחלט על המשתמש ו/או צד שלישי כלשהו להכניס שינויים, לבצע הליך הנדסה לאחור, להעתיק, לפרסם, להפיץ, לשדר, להציג בפומבי, לבצע, לשכפל, להנפיק רישיון, ליצור עבודות נגזרות, למכור או למסור לצד שלישי וכיו"ב כל חלק מן התוכן מבלי לקבל את הסכמתה המפורשת של האגודה, מראש ובכתב.
</StyledText>}/> 

<Section
        number={'43.'}
        text={<StyledText
          align={'left'}
      >
        לבד מרישיון השימוש בכפוף להוראות ההסכם, ללקוח אין ולא תהיה כל זכות בקשר למערכת ו/או זכויות כאמור ו/או טענה, דרישה ו/או תביעה בקשר לכך.

   </StyledText>}/> 

<Section
        number={'44.'}
        text={<StyledText
          align={'left'}
      >
        הלקוח אינו רשאי להעביר לצד שלישי את זכות השימוש במערכת והוא ישמור בסודיות את תוכנה ואת נתוניה, וינקוט בכל הצעדים הדרושים כדי למנוע מצד ג' את העתקתה והשימוש בה, כולה או חלקה.
         </StyledText>}/> 

<Section
        number={'45.'}
        text={<StyledText
          align={'left'}
      >
        ביחסים שבין הצדדים בין הצדדים, הלקוח הנו הבעלים של כל הזכויות, בכל נתוני הלקוח, והוא מעניק לאגודה רישיון שימוש בנתוני הלקוח לשם אספקת השירותים. כל זכויות הקניין הרוחני בקשר עם האפליקציה מכל מין וסוג שהוא (וזאת בין אם המדובר בזכויות רשומות ובין אם המדובר בזכויות שטרם נרשמו), ובכלל זאת שם המתחם ("Domain"), הפטנטים, סימני המסחר, שמות המסחר, המדגמים, זכויות יוצרים, סודות מסחריים, השיטות, אופן הצגתה ועיצובה של האפליקציה וכן כל עניין ו/או פרט הקשורים באפליקציה, הינם רכושה המלא והבלעדי של האגודה ו/או מי מטעמה ו/או של צד שלישי, אשר הרשה לאגודה לעשות בהן שימוש. משכך, אין להעתיק, להפיץ, לשכפל, למכור, לתרגם ו/או לבצע פעולה אחרת כלשהי בכל סוגי הטקסטים ו/או קודים ו/או תמונות ו/או סמני מסחר ו/או תצלומים ו/או סרטונים ו/או כל תוכן אחר המופיע באפליקציה, אלא אם התקבל לכך אישור מפורש מהאגודה, מראש ובכתב.
  </StyledText>}/> 
<Section
        number={'46.'}
        text={<StyledText
          align={'left'}
      >
        סימני המסחר ומודעות הפרסומת של מפרסמים באפליקציה (ככל שקיימים), הינם קניינם של מפרסמים אלה בלבד. מובהר כי גם בהם אין לעשות כל שימוש מבלי לקבל את הסכמתם המפורשת של המפרסמים, מראש ובכתב.
  </StyledText>}/> 
<StyledMainText
        align={'left'}
      >
<u>יג. ביטול הסכם</u>
      </StyledMainText>
<Section
        number={'47.'}
        text={<StyledText
          align={'left'}
      >
        כל צד רשאי לבטל את הסכם בכל עת מכל סיבה ו/או ללא סיבה, וזאת בהודעה בכתב של 90 ימים מראש לצד השני.
  </StyledText>}/> 

<Section
        number={'48.'}
        text={<StyledText
          align={'left'}
      >
כל צד רשאי לסיים את ההסכם, באופן מידי, באמצעות הודעה בכתב במידה והצד השני מבצע הפרה מהותית להסכם זה והפרה לא רופאה (במידה שההפרה ברת ריפוי) שלושים (30) ימים לאחר קבלת ההודעה בכתב האמורה.
   </StyledText>}/> 
<Section
        number={'49.'}
        text={<StyledText
          align={'left'}
      >
כל צד רשאי לסיים מידית את ההסכם בהודעה בכתב במידה ו- (1) הצד השני נהיה חדל פירעון; (2) עם פתיחת הצד השני בהליכי חדלות פירעון, כינוס נכסים או פשיטת רגל או כל הליך אחר להסדר חוב; (3) עם פתיחת הליכים שכאלה כנגד הצד השני, אשר אינם מבוטלים או נפתרים בדרך אחרת לטובת אותו הצד תוך שישים (60) ימים לאחר מכן; ו/או (4) במידה והצד השני מבצע המחאה כללית לטובת נושיו.
   </StyledText>}/> 
<StyledMainText
        align={'left'}
      >
<u>יד. אפקט הסיום</u>
      </StyledMainText>
<Section
        number={'50.'}
        text={<StyledText
          align={'left'}
      >
במקרה של סיומו, פקיעתו ו/או ביטולו כדין של ההסכם, מכל סיבה שהיא, יחול האמור להלן:
<ul>
<li>הרישיון יתבטל מאליו;</li>
<li>האגודה תשבית את גישתו של הלקוח וכל המשתמשים למערכת ולשירותים ואת יכולת השימוש של הלקוח בהם;</li>
<li>הלקוח ישיב לאגודה מידית חומרים מכל סוג שסופקו לו על ידי האגודה, כולל כל מידע סודי כאמור;</li>
<li>גישה לנתוני הלקוח - הלקוח יאבד כל גישה לכל נתוני לקוח אשר האגודה עשויה לאחסן במסגרת ההסכם. על אף האמור, למשך תקופה של שלושים (30) ימים ממועד ביטולו של הסכם זה, תספק האגודה ללקוח עם בקשת הלקוח בכתב, הזדמנות סבירה להוריד את נתוני הלקוח;</li>
</ul>
</StyledText>}/>

<p>בכפוף לדין, האגודה שומרת את הזכות למחוק לצמיתות כל נתוני לקוח בכל עת לאחר תקופת שלושים (30) הימים, והלקוח מוותר על כל זכויות משפטיות שיתכן ויש לו כנגד האגודה לגבי נתוני הלקוח שנמחקו בהקשר לעיל.</p>

<Section
        number={'51.'}
        text={<StyledText
          align={'left'}
      >
סעיפים ו', י', יא׳, יב', יד', 48, ישרדו את ביטול ההסכם ויישארו בתוקף ללא כל הגבלת זמן.
   </StyledText>}/> 
<StyledMainText
        align={'left'}
      >
<u>טו. שונות</u>
      </StyledMainText>

<Section
        number={'52.'}
        text={<StyledText
          align={'left'}
      >
        הלקוח אינו רשאי להעביר, להסב, להמחות או לשעבד לאחר את חיוביו ו/או זכויותיו, כולן או חלקן, לפי ההסכם לרבות אך לא רק את רישיון השימוש במערכת, אלא אם קיבל הסכמת האגודה לכך בכתב ומראש. האגודה רשאית להמחות את ההסכם וכל חלק ממנו לכל צד ג' ללא צורך באישור הלקוח.
   </StyledText>}/> 

<Section
        number={'53.'}
        text={<StyledText
          align={'left'}
      >
  היה והאגודה לא תוכל לספק את השירותים כתוצאה מאירוע של כח עליון לרבות אך לא רק: מלחמה, אש, פרעות, כוחות טבע, רעידת אדמה, שביתות וסכסוכי עבודה, או כל נסיבות אחרות אשר הינן מעבר לשליטתה הסבירה, לא ייחשב הדבר להפרה של התחייבויותיה על פי ההסכם וללקוח לא תהא כל טענה נגד האגודה בקשר לכך.
 </StyledText>}/> 


<Section
        number={'54.'}
        text={<StyledText
          align={'left'}
      >
  סמכות השיפוט הבלעדית בכל הקשור להסכם ופרשנותו תהיה של בתי המשפט בתל אביב יפו, בלבד. בסכסוכים ו/או חילוקי דעות בהם יהיו מעורבים גם חברי הקהילה שהנם חברים באגודה השיתופית החקלאית, אזי, ככל שיתאפשר בנסיבות העניין, יבחנו הצדדים אפשרות להגיע להסכמה ביניהם ביחס לניהול ההליך באמצעות בוררות במסגרת התנועה הקיבוצית.
 </StyledText>}/> 
<Section
        number={'55.'}
        text={<StyledText
          align={'left'}
      >
  הלקוח אינו רשאי לקזז מסכומים שהוא חייב בתשלומם לפי ההסכם, סכומים כלשהם.
 </StyledText>}/> 

<Section
        number={'56.'}
        text={<StyledText
          align={'left'}
      >
ההסכם ממצה את מלוא ההסכמה בין הצדדים והוא מבטל כל הסכם, הסכמה, מצג קודם או התחייבות אחרת.
 </StyledText>}/> 

<Section
        number={'57.'}
        text={<StyledText
          align={'left'}
      >
כל שינוי בהסכם או ויתור על תנאי הקבוע בו טעונים מסמך בכתב בחתימת שני הצדדים, שאם לא כן - לא יהיה להם תוקף.
 </StyledText>}/> 

<StyledSubTitle
      >
      <strong>פלטפורמת 'מקומי' &ndash;</strong> <strong>מדיניות הפרטיות</strong>
      </StyledSubTitle>

<StyledMainText
        align={'left'}
      >
 1. כללי
      </StyledMainText>      

<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
<ul>
<li>משתמש יקר! מקומי-נט פתרונות תשלום ומידע בקיבוצים אגש"ח בע"מ ויתר החברות בקבוצת משקי הקיבוצים אגש"ח בע"מ &ndash; משקי פיננסים אגש"ח בע"מ, סחר משק מועדונים אגש"ח בע"מ, משקי ליסינג אגש"ח בע"מ, וכן ביטוח חקלאי אגודה שיתופית מרכזית בע"מ, וענא-גל ניהול 2009 בע״מ (להלן יחדיו <strong>"הקבוצה"</strong>) מכבדות את פרטיותך, כמו גם את פרטיותם של כלל לקוחותיה והמשתמשים בשירותי הקבוצה (להלן "<strong>המשתמש" </strong>ו/או "<strong>המשתמשים</strong>"), לרבות המשתמשים באתר האינטרנט של הקבוצה המפעיל את מערכת 'מקומי', אפליקציית 'מקומי', וכן הנעזרים בשירותים הניתנים באמצעים הדיגיטליים והטלפוניים השונים של הקבוצה (להלן "<strong>השירותים</strong>").</li>
<li>מטרת מדיניות פרטיות זו הנה לפרט אודות המידע הנאסף אודותיך על ידי הקבוצה, לרבות עקב השימוש בשירותים, וכן לסקור את האופן שבו משתמשת הקבוצה במידע שנמסר לה והנאסף על ידה אגב השימוש בשירותים. תשומת ליבך כי עבור שירותים ו/או יישומים ספציפיים עשויים לחול כללים שונים ויתכן שתפורסם בצידם מדיניות פרטנית ביחס לשימוש במידע שייאסף באותו יישום.</li>
<li>תנאי מדיניות הפרטיות המפורטים להלן מהווים חלק בלתי נפרד <strong><u>מתנאי השימוש</u></strong>. הקבוצה רשאית לשנות מעת לעת את מדיניות הפרטיות ואת תנאי השימוש, יחד או לחוד, כך שישקפו שינויים טכנולוגיים, עסקיים, משפטיים או רגולטוריים. עדכונים ביחס למדיניות הפרטיות כאמור יפורסמו במסמך זה, אשר ימצא במתכונתו המעודכנת באתר האינטרנט של הקבוצה ובאפליקציה (להלן <strong>"אתרי הקבוצה"</strong>). שימוש באתרי הקבוצה כפוף למדיניות הפרטיות העדכנית בהם, ויעיד על הסכמתך למדיניות הפרטיות וכן לשינויים בה &ndash; על כן אנו ממליצים לעיין במדיניות הפרטיות מעת לעת.</li>
<li>כל ההגדרות והמונחים במדיניות הפרטיות יהיו כמשמעם בתנאי השימוש, אלא אם הקשרם של הדברים מחייב אחרת.</li>
</ul>
 </StyledText>}/> 
 <p>
  <strong>אנו מכבדים את פרטיותך ומחויבים להשתמש בשיטות פרטיות שקופות והוגנות. קרא בעיון את מדיניות הפרטיות הזו. אם אינך מסכים לה, אנא הימנע לעשות שימוש בשירותי הקבוצה. </strong>
 </p>



<StyledMainText
        align={'left'}
      >
 2. הגדרות 
</StyledMainText>      
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
<ul>
<li><strong>"חוק הגנת הפרטיות" &ndash; </strong>חוק הגנת הפרטיות, התשמ"א-1981.</li>
<li><strong>"מאגר מידע"</strong> &ndash; אוסף פרטי מידע אישי המעובד באמצעי דיגיטלי.</li>
<li><strong>"מידע איש&rdquo;" &ndash; </strong>נתון הנוגע לאדם מזוהה או לאדם הניתן לזיהוי &ndash; מי שניתן לזהותו במאמץ סביר, במישרין או בעקיפין, ובכלל זה באמצעות פרט מזהה.</li>
<li><strong>"בעל שליטה במאגר מידע" &ndash; </strong>מי שקובע, לבדו או יחד עם אחר, את מטרות עיבוד המידע שבמאגר המידע או גוף שהוא או בעל תפקיד בו הוסמך בחיקוק לעבד מידע במאגר מידע.</li>
<li><strong>"מחזיק במאגר מידע" &ndash; </strong>גורם חיצוני לבעל השליטה במאגר המידע המעבד בעבורו מידע.</li>
<li><strong>"עיבוד" &ndash; </strong>כל פעולה שמבוצעת על מידע אישי, לרבות קבלתו, איסופו, אחסונו וכיו"ב.</li>
<li><strong>"משתמש" &ndash; </strong>לקוחות, חברי קהילה משתמשי אפליקציה. למען הסר ספק, גולש בשירותים מקוונים, וכן משתמש לתקופת ניסיון ו/או גולש ארעי, ייחשבו לעניין הוראות מסמך זה כמשתמש לכל דבר ועניין, והשימוש על ידם בשירותי הקבוצה מהווה הסכמה לכל האמור בו ללא סייג.</li>
</ul>
 </StyledText>}/> 
<StyledMainText
        align={'left'}
      >
  3. ממונה על הגנת הפרטיות
</StyledMainText>      
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
<p>הנהלת הקבוצה מינתה ממונה על הגנת הפרטיות כנדרש בחוק הגנת הפרטיות.</p>
<p>ליצירת קשר הם הממונה על הגנת הפרטיות ניתן לשלוח דוא"ל לכתובת &nbsp;<a href="mailto:avig@experda.com">avig@experda.com</a></p>
 </StyledText>}/> 
<StyledMainText
        align={'left'}
      >
  4. איסוף מידע 
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
<ul>
<li>חלק מהשירותים הניתנים טעונים הרשמה ו/או מסירת מידע אישי, כדוגמת:</li>
<li>פרטי זיהוי ישירים &ndash; שם מלא, מגדר, גיל, מספר תעודת זהות, כתובת, דוא"ל, טלפון, קשרים משפחתיים, וכן מידע פיננסי, כגון פרטי חיוב משתמש, דפי תקציב ושכר, פרטי רכישות ואמצעי תשלום, פרטי חשבון בנק, ופרטים פעילות של משתמשים, תכנים המועלים על ידי משתמשים למערכת, לרבות נתוני שימוש שונים, כגון מועד משלוח וקבלה של הודעות, סטטוס קריאת הודעות, מיקום (לגבי הודעות מבוססות מיקום), פרטי הצבעות דיגיטליות, פרוטוקולים, תורנויות, קריאות שירות, וכן כל מידע אשר עשוי להיות נחוץ לצורך תפעול, מתן השירותים, שיפורם וייעולם. המידע לעיל מאפשר לך גם, בין היתר, להתחבר לאזור האישי שלך, בו תידרש להזדהות, בין אם על ידי שם המשתמש והסיסמא שלך, או לחילופין, אם תגדיר זאת במכשירך, על ידי הזנת טביעת אצבע, זיהוי פנים או כל אמצעי הזדהות אחר שיוטמע במסגרת השירותים, האפליקציה ובאתרי הקבוצה (להלן "<strong>הזדהות</strong>").</li>
<li>מידע נוסף אודותיך עשוי להיאסף במסגרת השימוש בשירותים, כגון מידע סטטיסטי או מידע אחר הקשור בשימושך בשירותים, לרבות מידע אודות פעולות שלא הושלמו במסגרת השירותים [דוגמת מילוי טופס או הפסקת תהליך באמצעו, לחיצה על באנרים וכד' (כולם יחדיו מהווים חלק מהמידע הנמסר)].</li>
<li>מובהר כי אינך מחויב למסור פרטים אלו על פי דין, ומסירתם תלויה אך ברצונך ובהסכמתך החופשיים, על מנת לקבל את שירותי הקבוצה המבוקשים. עם זאת, תשומת ליבך כי ללא מסירת פרטים מסוימים (למשל, ללא הזדהות), לא נוכל לתפעל ולספק את השירותים המוצעים, חלקם או כולם.</li>
<li>בעת ביצוע פעולות מסוימות במסגרת השירותים, ייתכן ותידרש העברת מידע גם לספקים, המיישמים את ביצוע הפעולה, ולצדדים הקשורים באותה פעולה &ndash; דוגמת ספקי מחשוב, חברות סליקה, ספקי שירותי ענן (אחסון המידע) וכיוצא באלו. המידע יישמר אצל הקבוצה וכן יועבר לצדדים הרלוונטיים לשם השלמת הפעולות.</li>
<li>כלל המידע שנמסר ו/או ייאסף אודותיך לצורך אספקת השירותים, כולם או מקצתם ו/או במהלך אספקתם, ישמר במאגרי המידע הרשומים והמאובטחים של הקבוצה, שהינה בעלת השליטה במאגרי מידע אלה, ויוחזק על ידה ו/או על ידי מי מטעמה, לרבות באמצעות שירותי "ענן", <strong>בארץ ו/או בחו"ל</strong>. השימוש במידע יהיה בהתאם למטרות מאגרים אלו ולאמור במדיניות זו ו/או במדיניות הפרטנית של השירות בו אתה משתמש.</li>
<li>יש למסור מידע ו/או לעדכן באתר מידע נכון, אמין ומדויק, רק בשמך ועבור עצמך, ולא בשם ו/או עבור צדדים שלישיים, למעט במקרים בהם הורשית לעשות כן, במפורש ובכתב. מסירת המידע על ידי משתמש אודות אחרים תתבצע על אחריות מוסר המידע.</li>
</ul>
</StyledText>}/>    
<StyledMainText
        align={'left'}
      >
 5. מזהים דיגיטליים ו - Cookies
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
        <ul>
<li>לידיעתך &ndash; השירותים משתמשים בתוכנות צוברות מידע, בעזרת 'עוגיות' ודומיהן &ndash; דוגמת pixels, tags (להלן יחדיו "<strong>Cookies</strong>" ו/או "<strong>עוגיות</strong>"), לצורך תפעולם השוטף והתקין, לשם אבטחת הנתונים בהם והמידע הנמסר, ובכלל זה כדי לאסוף נתונים סטטיסטיים אודות השימוש בשירותים, לשם קבלת החלטות בנוגע לפרופיל שלך ו/או פעילותך, לשם אימות פרטים וזיהוי, מניעת הונאות ותרמיות, לשם שיפור חווית הגלישה והשימוש בשירותים ובאתרי הקבוצה, תוך התאמת התכנים והשירותים להעדפותיך האישיות, לשם אפיון המוצרים המתאימים לך, להתאים עבורך פרסומות ותכנים הרלבנטיים אליך, אף בגלישתך באתרים אחרים, הכל למטרות סטטיסטיות, מחקריות, שיווקיות ומסחריות, וכמובן לצרכי אבטחת מידע.</li>
<li>עוגיות, באופן כללי ובתמצית, הן קבצי טקסט אשר הדפדפן או היישומון שהמשתמש יוצר לפי פקודה ממחשבי הקבוצה. חלק מהעוגיות יפקעו כאשר תסגור את הדפדפן או את היישום הרלבנטי, ואחרות נשמרות על גבי זיכרון המכשיר או המחשב שלך.</li>
<li>העוגיות מכילות ואוספות מידע מגוון כדוגמת הדפים שבהם ביקרת, משך הזמן ששהית באתר ו/או באפליקציה, מהיכן הגעת אל האתר ו/או הדף, כתובת ה-IP שלך, מאפייני המכשיר שלך, ומידע שתבקש לראות בעת הכניסה לאתר ועוד. כמו כן יכול והעוגיות ישמרו אף מידע בדבר הרגלי הגלישה שלך באתרים אחרים, לרבות האתרים בהם גלשת, העמודים באתרים/באפליקציה וכל פעולה אחרת בהם. המידע בעוגיות מוצפן, והקבוצה נוקטת צעדי זהירות כדי להבטיח שרק מחשבי הקבוצה או מי מטעמה יוכלו לקרוא ולהבין את המידע האגור בהם. השירותים עשויים לעשות שימוש אף בעוגיות צד ג' &ndash; למשל עוגיות של חברת Facebook ו-Google כגון אלו המוטמעות תוך שימוש ב- Google Analytics, העוזרות לנו להתאים עבורך את חווית הגלישה או השימוש, ולהסיק תובנות סטטיסטיות בנוגע לכלל השימושים בשירותים.</li>
<li>אם אינך רוצה לקבל עוגיות, תוכל להימנע מכך על ידי שינוי ההגדרות בדפדפן שלך. לשם כך נא היוועץ בקובץ העזרה של הדפדפן. זכור, עם זאת, כי נטרול העוגיות עלול לגרום לכך שלא תוכל להשתמש בחלק מהשירותים והתכונות באתר.</li>
<li>יש למסור מידע ו/או לעדכן באתר מידע נכון, אמין ומדויק, רק בשמך ועבור עצמך, ולא בשם ו/או עבור צדדים שלישיים, למעט במקרים בהם הורשית לעשות כן, במפורש ובכתב.</li>
</ul>
</StyledText>}/>    
<StyledMainText
        align={'left'}
      >
6. מטרות השימוש במידע וגישה למכשיר קצה
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
<ul>
<li>אתה עשוי להתבקש לאשר גישה לשירותים מסוימים ממכשירך, בין אם מהמחשב, הטלפון הנייד או כל מכשיר קצה אחר, וזאת לטובת ביצוע פעולות במסגרת השירותים (למשל &ndash; ללא אישור גישה לגלריית תמונות, לא תוכל להעלות תמונות ממכשירך).</li>
<li>אינך חייב לאשר את השירותים האלו, וכמו כן תוכל לסגור את הגישה אליהם דרך מכשירך, אולם סגירת הגישה כאמור עשויה להוביל לכך שלא תוכל לקבל את השירותים המסופקים, כולם או חלקם.</li>
<li>הקבוצה רשאית לעשות שימוש במידע לשם תפעול ואספקת השירותים, וכן לשם קבלת החלטות ביחס אליך או אחרים, בנושאים של מתן המלצות, מניעת הונאות, למטרות תפעוליות, גילוי תרמיות ו/או פעילות בלתי חוקית אחרת, ביטחון כללי, אבטחת השירותים, ויצירת קשר עמך.</li>
<li>בנוסף המידע ישמש על מנת לשפר, להעשיר או לשנות את השירותים והתכנים המוצעים במסגרתם, איתור תקלות ופתרונן, על מנת לייעל ולנהל את הקשר עמך וכן לשם עריכת סקרים באשר לשירותים המוצעים על ידי הקבוצה, מי מטעמה ו/או על ידי צדדים שלישיים הקשורים עם הקבוצה בהסכם.</li>
<li>הקבוצה תוכל להשתמש ולעבד את המידע גם למטרות ניהול, ייעול, התאמה ושיווק של שירותי הקבוצה, בין היתר על ידי יצירת אפיון אודותיך, לרבות על ידי הצעת הצעות שיווקיות המותאמות אישית עבורך, וכן לעשות שימוש בנתונים סטטיסטיים, שלא יזהו אותך באופן אישי, למטרות המנויות לעיל &ndash; דוגמת מחקר והסקת מסקנות אודות השימוש בשירותים ו/או המשתמשים בהם.</li>
<li>הקבוצה עשויה לשלוח אליך הודעות תפעוליות, התראות ועדכונים בדרכים שונות ובין היתר באמצעות המייל או באמצעות מסרונים, כגון מסרון המכיל קוד הזדהות לשם גישה לאתר ו/או לאפליקציה, או לשם שחזור סיסמא, או הודעות ביחס לפעולותיך, אישורי ביצועי פעולות או הוראות ביצוע ושימושים שונים בשירותים.</li>
<li><strong>במסגרת שירותי הקבוצה עשויות להופיע פרסומות ו/או קישורים שונים לאתרים ו/או יישומים חיצוניים</strong>. לחיצה על הקישור תעשה על דעתך ועל אחריותך בלבד, שכן תצא משירותי הקבוצה ותופנה לאתר ו/או יישום חיצוני, ותהיה כפוף לתנאיו, לרבות מדיניות הפרטיות שלו. מאותו שלב, לקבוצה לא תהיה שליטה על הנעשה במידע שלך, ולפיכך לא תישא באחריות ביחס לכך.</li>
<li>מבלי לגרוע מהאמור לעיל, הקבוצה רשאית לשלוח אליך וליצור אתך קשר, מעת לעת, בדואר אלקטרוני ו/או באמצעי התקשרות אחרים מידע בדבר שירותיה, והצעות מותאמות אישית גם בדרך של דיוור ישיר. תהיה רשאי לבקש לחדול מקבלת המידע כאמור, באמצעות שליחת מייל לכתובת privacy@mekome.net.</li>
</ul>
</StyledText>}/>    

<StyledMainText
        align={'left'}
      >
7. מסירת מידע לצד שלישי
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
     <ul>
<li>הקבוצה עשויה להעביר מידע אודותיך לצדדים שלישיים מעת לעת, במספר מקרים, כפי שיפורט להלן, ו/או בכל מקרה אחר בו תידרש הקבוצה להעברה:
<ul>
<li>על פי דרישת המשתמש ו/או בהסכמתו המפורשת;</li>
<li>לצורך העברתם לספקי המוצרים ו/או השירותים על מנת להשלים את הפעולות המבוקשות על ידך ו/או כאשר נדרש לשם תפעול השירותים, כגון חברות סליקה חיצוניות לשם ביצוע התשלום בגין השירות, ולרבות ספק שירותי ענן;</li>
<li>במסגרת פעילותה מול חברות קשורות עסקית, למען מטרות השימוש המוצהרות ומותרות לפי כל דין, לשם אספקת השירותים, ולרבות לצורך ניהול הסיכונים בקבוצה.</li>
<li>בכל מקרה בו תפר את תנאי השימוש, לרבות תנאי מדיניות הפרטיות ו/או במקרים בהם תבצע או תנסה לבצע, בעצמך ו/או באמצעות מי מטעמך, באמצעות השירותים ו/או בקשר עמם, פעולות המנוגדות להוראות תנאי השימוש, לרבות מדיניות הפרטיות, ולרבות הפרת הוראות כל דין;</li>
<li>בשל צו שיפוטי המורה לקבוצה למסור את המידע לצדדים שלישיים בהתאם לצו;</li>
<li>לכל אדם, תאגיד, גוף, רשות וגורם ממשלתיים, ציבוריים, פרטיים או אחרים על פי כל הוראה בדין המחייבת או הטילה על הקבוצה חבות לעשות זאת;</li>
<li>לצרכי ניהול הליך ו/או מחלוקת משפטית ו/או חוקית, שבינך ו/או מי מטעמך לבין הקבוצה ו/או מי מטעמה;</li>
<li>בכל מקרה בו תסבור הקבוצה, כי מסירת המידע נחוצה על מנת למנוע נזק חמור לקבוצה, ו/או לרכושו ו/או גופו של המשתמש ו/או של צדדים שלישיים, או על מנת למנוע נזק חמור אחר לפי שיקול דעתה הבלעדי;</li>
<li>במקרה בו העבירה ו/או המחתה הקבוצה לצד שלישי את פעילותה ו/או את זכויותיה וחובותיה כלפי המשתמש גם במקרה של שינוי בשליטה בקבוצה ו/או באחת החברות בה, לרבות בדרך של מיזוג, רכישה, או רכישה של כלל או עיקר נכסיה, ובלבד שצדדים שלישיים כאמור יקבלו על עצמם את ההוראות המפורטות במדיניות פרטיות זו.</li>
</ul>
</li>
<li>הקבוצה עשויה למסור מידע סטטיסטי לצדדים שלישיים, לרבות מפרסמים, וזאת בכפוף לתנאי מדיניות פרטיות זו. מידע סטטיסטי שיימסר לצדדים שלישיים לא יזהה אותך באופן אישי.</li>
<li>אין באמור לעיל בכדי לגרוע מזכות הקבוצה להעביר לצדדים שלישים מידע שאינו אישי, אשר אין בו בכדי לזהות אותך בשמך ו/או בפרטי זהותך באופן ישיר.</li>
</ul>
</StyledText>}/>    

<StyledMainText
        align={'left'}
      >
8. זכות לעיון, תיקון ומחיקת המידע
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
     <ul>
<li>זכות לעיון במידע ותיקונו תינתן על ידי הקבוצה בהתאם להוראות חוק הגנת הפרטיות, התשמ"א -1981 (להלן: "חוק הגנת הפרטיות").</li>
<li>הינך זכאי לעיין במידע המוחזק אודותיך במאגר המידע של הקבוצה, בעצמך או באמצעות בא כוחך שהורשה בכתב או על ידי אפוטרופוס. הקבוצה תשיב לך על בקשתך בהקדם האפשרי ותאפשר לעיין במידע אודותיך לא יאוחר מ-30 יום מיום הגשת הבקשה.</li>
<li>הינך זכאי, לאחר שעיינת במידע אודותיך ומצאת כי הוא אינו נכון, שלם, ברור או מעודכן, לבקש לתקן או למחוק את המידע אודותיך ו/או לתקנו. הקבוצה תשיב לך על בקשתך בהקדם האפשרי ולא יאוחר מ-30 יום מיום הגשת הבקשה.</li>
<li>לצורך כך, הינך מוזמן לפנות אלינו לכתובת: <a href="mailto:privacy@mekome.net">privacy@mekome.net</a>.</li>
<li>הקבוצה רשאית לשמור עותק מהמידע בארכיב, כנדרש על פי חוק או לצרכים עסקיים חוקיים.</li>
</ul>
</StyledText>}/>    

<StyledMainText
        align={'left'}
      >
        9. דיוור ישיר ושליחת הודעות
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
        <ul>
<li>הקבוצה עשויה לשלוח אליך מפעם לפעם מידע הקשור אליה ו/או לשירותיה. תוכל לבטל את הסכמתך ולא לקבל יותר מסרים כאמור באמצעות לחיצה על כפתור ההסרה בתחתית ההודעה או בהודעה לכתובת: <a href="mailto:privacy@mekome.net">privacy@mekome.net</a></li>
</ul>
</StyledText>}/>    

<StyledMainText
        align={'left'}
      >
       10. אבטחת מידע
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
       <ul>
<li>ידוע לך, כי הקבוצה מקדישה משאבים ונוקטת אמצעים מחמירים למניעת חדירה לפלטפורמות המגישות את השירותים, ולסיכול פגיעה אפשרית בפרטיות המשתמש, אולם אינה יכולה למנוע שיבושים בשירותיה באופן מוחלט.</li>
<li>הקבוצה מתחייבת לעמוד בהוראות כל דין לעניין אבטחת מידע, לרבות חוק הגנת הפרטיות, ותקנות הגנת הפרטיות (אבטחת מידע), התשע"ז 2017.</li>
<li>הקבוצה מיישמת מערכות ונהלים עדכניים ומחמירים לאבטחת מידע ומשקיעה מאמצים רבים ביישום ובשמירה על אבטחת האפליקציה והמידע האישי של המשתמשים (בין בעצמנו ובין באמצעות קבלת שירותים מצדדים שלישיים שהינם ספקי שירותים מוסמכים).</li>
<li>הקבוצה מיישמת נהלים ומדיניות אבטחת מידע כמקובל בתעשייה על מנת להבטיח את אבטחת המידע של המשתמשים ועל מנת למנוע כל שימוש לא מורשה במידע זה, לרבות גניבת זהות ו"דיוג" (Phishing&rdquo;).</li>
<li>באחריות המשתמש לנקוט אמצעי הגנה על מכשיר הקצה המשמש למתן השירותים, ולשמור על חיסיון הסיסמא לאפליקציה (אזור אישי) ולא להעבירה לאף גורם אחר.</li>
<li>הקבוצה תדווח לרשויות הרלוונטיות על כל אירוע אבטחת מידע שעשוי לסכן ו/או לפגוע באבטחת המידע באופן מידי מהרגע בו נודע לה על האירוע.</li>
</ul>
</StyledText>}/> 

<StyledMainText
        align={'left'}
      >
       11. שינויים במדיניות הפרטיות
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
       <ul>
<li>הקבוצה שומרת על הזכות לשנות מדיניות פרטיות זו בכל זמן ובהתאם לשיקול דעתה הבלעדי, ומבקשת מכלל המשתמשים לשוב ולבקר בדף זה לעתים קרובות ככל הניתן. השינויים במדיניות הפרטיות ייכנסו לתוקף בתאריך העדכון האחרון של המסמך, והמשך השימוש באפליקציה לאחר תאריך העדכון האחרון יהווה הסכמה של המשתמש לשינויים.</li>
<li>במידה ומדיניות הפרטיות תתוקן בכדי להיענות לכל דרישה חוקית, התיקונים עשויים להיכנס לתוקף באופן מידי, או כפי שנדרש על פי דין. באחריות המשתמש לבדוק את מדיניות הפרטיות ותאריך העדכון שלה מעת לעת.</li>
</ul>
</StyledText>}/>

<StyledMainText
        align={'left'}
      >
       12. צור קשר
</StyledMainText>   
<Section
        number={''}
        text={<StyledText
          align={'left'}
      >
    <ul>
<li>הנך מוזמן ליצור עמנו קשר בכל שאלה או בעיה הקשורה בשירותים ו/או במדיניות הפרטיות באמצעות אמצעי התקשורת במפורסמים באתר או באמצעות שירות לקוחות של מקומי נט: טלפון מס': 04-9001970, כתובת דוא"ל: <a href="mailto:office@mekome-net.com"><strong>office@mekome-net.com</strong></a></li>
</ul>
</StyledText>}/>
</Content>
  )
}

export default Terms
